import { css } from '@emotion/react';

const ShareLinkStyles = css`
    height: auto;
    cursor: pointer;
    padding: 5px;
`;

export const themeShareLinkStyles = css`
    i {
        color: var(--default-text-color);
        font-size: var(--body-small-fontSize);
    }
`;

export default ShareLinkStyles;
